import { useContext, type ReactNode } from 'react';
import { RadioGroup } from '@headlessui/react';
import clsx from 'clsx';
import { QuizContext } from '../../quiz-context';
import { type QuizTypes, type Quiz } from '../../quiz-hooks';
import styles from './ControlRadio.module.css';

interface Props<T extends keyof Quiz> {
  question: T;
  children?: ReactNode;
  layoutVariant?: 'one-column' | 'two-column';
}

export function ControlRadio<T extends keyof Quiz>(props: Props<T>) {
  const { children, question, layoutVariant } = props;
  const { quiz, onQuestionAnswer } = useContext(QuizContext);
  const quizValue = quiz[question];

  return (
    <RadioGroup
      value={quizValue}
      onChange={(nextValue) => {
        onQuestionAnswer(quiz, question, nextValue);
      }}
      className={clsx({
        [styles['one-column']]: layoutVariant === 'one-column',
        [styles['two-column']]: layoutVariant === 'two-column',
      })}
    >
      {children}
    </RadioGroup>
  );
}

ControlRadio.Option = (props: { children: ReactNode; value: QuizTypes }) => {
  const { children, value } = props;
  return <RadioGroup.Option value={value}>{children}</RadioGroup.Option>;
};
